import { fetchKPI } from './actions';

export const kpi = {
    fetchKPI,
};
